<template>
    <div class="pb-80 font-satoshi_r">
        <div class="flex flex-col justify-end items-center px-4 sm:px-6">

            <div class="">
                <h1 class="text-1xl font-medium text-cream-500 mb-3">
                    Nice try, but you’ve already voted!
                </h1>
                <p class="text-base font-medium text-gray-x10">
                    Only one vote is allowed per person, and yours is already in. Please return to the app by using the close button at the top of your screen.
                </p>
            </div>

            <!-- <div class="w-full px-3"> pb-64 sm:pb-72
                <a 
                    href="https://sphinx.sycamore.ng/public/dashboard/16c193e1-771e-4a51-bb18-e7134b550a15" 
                    class="button is-primary is-medium is-fullwidth font-satoshi_r mt-20"
                >
                    <span class="text-sm">View leaderboard</span>
                </a>
            </div> -->
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },

    data() {
        return {
            isLoading: true,
        }
    },

    methods: {
    },

    mounted() {
    },
};
</script>

<style scoped>
    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .button {
        border-radius: 12px !important;
    }
</style>
